import React, { useState, useEffect } from "react";
import "./CustomAudioPlayer.scss";
import { FaPlay, FaPause, FaDownload } from "react-icons/fa";
import { BsVolumeUpFill } from "react-icons/bs";
import { SvgIcon, Box } from "@material-ui/core";
import axios from "axios";
import { Howl } from "howler";

export const CustomAudioPlayer = ({ src, fileName = "download.wav", prompt={} }) => {
	const [isPlaying, setIsPlaying] = useState(false);
	const [currentTime, setCurrentTime] = useState(0);
	const [duration, setDuration] = useState(0);
	const [volume, setVolume] = useState(1);
	const [howl, setHowl] = useState(null);
	const [showVolumeControl, setShowVolumeControl] = useState(false);
	const [isEnabled, setIsEnabled] = useState(true);

	useEffect(() => {
		try {
			const sound = new Howl({
				src: [src],
				format: ["wav"],
				onload: () => setDuration(sound.duration()),
				onplay: () => {
					requestAnimationFrame(updateProgress);
				},
				onend: () => {
					setIsPlaying(false);
					setCurrentTime(0);
				},
				onloaderror: (id, err) => {
					console.log("fail to load audio", err);
					setIsEnabled(false);
				}
			});

			setHowl(sound);

			return () => {
				sound.unload();
			};
		} catch (e) {
			console.log("e", e);
		}
	}, [src]);

	const togglePlay = () => {
		if (!howl) return;

		if (isPlaying) {
			howl.pause();
		} else {
			howl.play();
		}
		setIsPlaying(!isPlaying);
	};

	const updateProgress = () => {
		if (howl && isPlaying) {
			const currentTime = howl.seek();
			setCurrentTime(currentTime);
			requestAnimationFrame(updateProgress);
		}
	};

	const handleTimelineChange = event => {
		const newTime = parseFloat(event.target.value);
		if (howl) {
			howl.seek(newTime);
		}
		setCurrentTime(newTime);
	};

	const handleDownload = async () => {
		try {
			const response = await axios.get(src, { responseType: "blob" });
			const blob = response.data;

			const blobURL = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = blobURL;
			link.download = fileName;
			document.body.appendChild(link);
			console.log("before click");
			link.click();
			console.log("link clicked");
			document.body.removeChild(link);

			setTimeout(() => {
				window.URL.revokeObjectURL(blobURL);
			}, 100);
		} catch (error) {
			console.error("Erro ao baixar arquivo:", error);
		}
	};

	const handleSpeedChange = event => {
		if (howl) {
			howl.rate(event.target.value);
		}
	};

	const handleVolumeChange = event => {
		const newVolume = parseFloat(event.target.value);
		if (howl) {
			howl.volume(newVolume);
		}
		setVolume(newVolume);
	};

	const formatTime = seconds => {
		const mins = Math.floor(seconds / 60);
		const secs = Math.floor(seconds % 60);
		return `${mins}:${String(secs).padStart(2, "0")}`;
	};

	return (
		<>
			<Box
				className="audio-container"
				style={{
					pointerEvents: isEnabled ? "auto" : "none",
					opacity: isEnabled ? 1 : 0.5
				}}
			>
				<button
					onClick={togglePlay}
					style={{ backgroundColor: "transparent", border: "none" }}
				>
					<SvgIcon>{isPlaying ? <FaPause /> : <FaPlay />}</SvgIcon>
				</button>
				<div className="timeline">
					<span>{formatTime(currentTime)}</span> /{" "}
					<span>{formatTime(duration)}</span>
					<input
						type="range"
						min="0"
						max={duration || 0}
						value={currentTime}
						onChange={handleTimelineChange}
						step="0.1"
					/>
				</div>
				<div
					className="volume-control"
					onMouseEnter={() => setShowVolumeControl(true)}
					onMouseLeave={() => setShowVolumeControl(false)}
				>
					<SvgIcon>
						<BsVolumeUpFill />
					</SvgIcon>
					{showVolumeControl && (
						<input
							type="range"
							min="0"
							max="1"
							step="0.01"
							value={volume}
							onChange={handleVolumeChange}
							className="volume-slider"
						/>
					)}
				</div>

				<label className="speed-control">
					Velocidade:
					<select onChange={handleSpeedChange} defaultValue="1">
						<option value="0.5">0.5x</option>
						<option value="1">1x</option>
						<option value="1.5">1.5x</option>
						<option value="2">2x</option>
					</select>
				</label>
				<button
					onClick={handleDownload}
					style={{ backgroundColor: "transparent", border: "none" }}
				>
					<SvgIcon>
						<FaDownload />
					</SvgIcon>
				</button>
			</Box>
		</>
	);
};

export default CustomAudioPlayer;
